import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"

let dev =  "/middle_school";

const url21 = '/manager/menu';//添加菜单
const url22 = '/manager/menu/'//删除菜单

const url1 = '/manager/role/list';
const url2 = '/manager/role';
const url3 = '/manager/menu/tree-all';//菜单树状列表
const url4 = '/manager/role/remove-ids';
const url5 = '/manager/menu/tree';




const apis = {

  //---菜单管理---
  menuSave(data) { //添加菜单
    return request({
      url: url21,
      method: 'post',
      data:data,
      jsonString:true
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  setNewPassWord(data){//修改密码
    return request({
      url:"/web/sso/resetPassword/sign",
      method: 'post',
      data:data,
      isToken: true,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  getSign(data){//修改密码
    return request({
      url:"/getSign",
      method: 'get',
      params:data,
      isToken: true,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  menuListTree(roleType){//菜单树状列表
    return request({
      url: url3,
      method: 'get',
      params:{
        roleType:roleType
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  menuListDel(id) {//账号单条删除
    return request({
      url: url22+'/'+id,
      method: 'delete',
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //---菜单管理---

  // 1.角色管理列表数据
  roleList(data) {
    return request({
      url: url1,
      method: 'get',
      params:{
        curPage:data.curPage,
        pageSize:data.pageSize,
        id:data.id,
        name:data.name,
        roleType:data.roleType
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

   // 2.获取菜单权限列表
  getMenuList(){
    return request({
      url: url3,
      method: 'get'

    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  // 3.添加角色
  addRole(data) {
    return request({
      url: url2,
      method: 'post',
      jsonString:true,
      data:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  // 4.删除角色
  delRole(id) {
    return request({
      url: url2+'/'+id,
      method: 'delete',
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  // 5.单条编辑
  editor(id){
    return request({
      url: url2+'/'+id,
      method: 'get',
      jsonString:true,
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },





  // 删除多条角色
  removeRoles(ids){
    //console.log(ids);
    return request({
      url: url4+"?ids="+ids,
      method:'delete'
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  // 获取左侧菜单列表
  getLeftMenuList(){
    return request({
      url: url5,
      method: 'get'
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },


}


export default apis



// WEBPACK FOOTER //
// ./src/core/api/configuration.serve.js